export default __webpack_public_path__ + "static/media/img_14.64528d6a.JPG";